<template>
  <div>
    <div class="mws-box card-body mws-search-box">
      <form method="GET" id="searchForm" @submit.prevent="submitSearch">
        <div class="mr-2 ml-2" style="float:left">
          <select v-model="fm_source_id" class="mws-search-edits" name="sourceid" id="id_sourceid" placeholder="Market">
            <option></option>
            <option
              v-for="source in sources"
              v-bind:value="source.source_id"
              :key="source.source_id"
            >
              {{ source.source_desc }}
            </option>
          </select>
        </div>
        <div class="mr-3 ml-2" style="float:left">
          <select v-model="fm_delivery_status" id="id_order_status" class="mws-search-edits" placeholder="Status">
            <option></option>
            <option
              v-for="(delstat, index) in delivery_statuses"
              v-bind:value="delstat.order_statuses"
              :key="index"
              >{{ delstat.order_statuses }}</option
            >
          </select>
        </div>
        <div class="mr-3 ml-2" style="float:right">                          
            <svg style="float:right;" type="submit" v-on:click="submitSearch()" xmlns="http://www.w3.org/2000/svg" width="41.999" height="43.5" viewBox="0 0 44.999 45.5">
              <path id="Loupe" d="M-2760.2-3440.5a2.2,2.2,0,0,1-1.556-.635l-12.484-12.318a17.641,17.641,0,0,1-10.16,3.186,17.5,17.5,0,0,1-17.6-17.366A17.5,17.5,0,0,1-2784.4-3485a17.5,17.5,0,0,1,17.6,17.366,17.229,17.229,0,0,1-4.192,11.247l12.345,12.181a2.141,2.141,0,0,1,.645,1.535,2.141,2.141,0,0,1-.645,1.535A2.2,2.2,0,0,1-2760.2-3440.5Zm-24.2-40.158a13.128,13.128,0,0,0-13.2,13.025,13.127,13.127,0,0,0,13.2,13.023,13.126,13.126,0,0,0,13.2-13.023A13.128,13.128,0,0,0-2784.4-3480.658Z" transform="translate(2802.5 3485.5)" fill="rgba(102,102,102,0.7)" stroke="rgba(0,0,0,0)" stroke-width="1"/>
            </svg>
        </div>
        <div class="mr-3 ml-2" style="float:right">
          <input
            v-model="fm_reference"
            id="id_order_ref"
            class="mws-search-edits"
            type="text"
            name="orderref"
            size="11"
            placeholder="Order ref."
          />
        </div>
        <div class="mr-3 ml-2" style="float:right" placeholder="To">
          <input
            v-model="fm_date_to"
            class="datestyle mws-search-edits"
            id="id_date_to"
            type="date"
            name="date_to"
          />
        </div>
        <div class="mr-3 ml-2" style="float:right" placeholder="From">
          <input
            v-model="fm_date_from"
            class="datestyle mws-search-edits"
            id="id_date_from"
            type="date"
            name="date_from"
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { apiService } from "../common/api.service";

export default {
  name: "searchBar",
  props: {
    def_source_id: {
      type: String,
      required: false
    },
    def_delivery_status: {
      type: String,
      required: false
    },
    def_fm_dt: {
      type: String,
      required: false
    },
    def_to_dt: {
      type: Date,
      required: false
    }
  },
  data() {
    return {
      creatingComponent: true,
      fm_source_id: 10, //this.def_source_id,
      fm_delivery_status: "Shipped", //this.def_delivery_status,
      // Past def props for dates don't seem to work at, needs more investigation
      // Set from date to 2 months prior to today
      fm_date_from: new Date(
        new Date().getFullYear(),
        new Date().getMonth() - 2,
        new Date().getDate()
      )
        .toISOString()
        .substr(0, 10),
      // Todays date
      fm_date_to: new Date().toISOString().substr(0, 10),
      sources: [],
      delivery_statuses: [],
      fm_reference: ""
    };
  },
  mounted() {},
  methods: {
    submitSearchClick() {
        this.submitSearch();
    },
    submitSearch() {
      if (this.creatingComponent) {
        // 1st run on creation, use/set defaults for search
        this.fm_source_id = 10;
        this.fm_delivery_status = "Shipped";
        this.fm_date_from = new Date(
          new Date().getFullYear(),
          new Date().getMonth() - 2,
          new Date().getDate()
        )
          .toISOString()
          .substr(0, 10);
        // Todays date
        (this.fm_date_to = new Date().toISOString().substr(0, 10)),
          (this.sources = []);
        this.delivery_statuses = [];
        this.fm_reference = "";
        this.creatingComponent = false;
      }

      var srchParams = "";
      if (this.fm_source_id) srchParams = this.fm_source_id;
      else srchParams = "0";
      srchParams += "/";

      if (this.fm_delivery_status) srchParams += this.fm_delivery_status;
      else srchParams += "X";
      srchParams += "/";

      if (this.fm_date_from) srchParams += this.fm_date_from;
      else srchParams += "X";
      srchParams += "/";

      if (this.fm_date_to) srchParams += this.fm_date_to;
      else srchParams += "X";
      srchParams += "/";

      if (this.fm_reference) srchParams += this.fm_reference;
      else srchParams += "X";
      srchParams += "/";

      this.$emit("search-request", srchParams);
    },
    async getSources() {
      let endpoint = "/api/sources/";
      await apiService(endpoint).then(data => {
        this.sources = data.results;
      });
    },
    async getDeliveryStatuses() {
      let endpoint = "/api/deliverystatuses/";
      await apiService(endpoint).then(data => {
        this.delivery_statuses = data;
      });
    }
  },

  created() {
    this.getSources();
    this.getDeliveryStatuses();
    this.submitSearch();
  }
};
</script>

<style scoped>
.datestyle {
  width: 140px !important;
}
.formatLabel {
  display: block !important;
  text-align: left !important;
}
input,
select {
  box-sizing: border-box;
  height: 25px;
}
</style>
